// US 提现页的统一入口（首页顶栏 / My Cash / 登录页顶栏都走这里）。
//
// 为什么不直接 router.push('/withdraw-us')：
// 主 SPA 跑在横屏 WebView 里，提现页靠 RotateFrame 把内容旋转 90° 假装竖屏，
// 但输入法是系统按 WebView 真实方向弹的，于是出现「内容竖屏、键盘横屏」。
// 安卓壳提供了 jskit.startPortraitPage(url)：另开一个真正竖屏的 WebView 加载 url，
// 这样内容和键盘方向一致，RotateFrame 在竖屏下本来就是 display:contents 不旋转。
//
// 新 WebView 是同源的另一次 SPA 加载：把当前 query 原样带过去，index.html 会重新解析一遍
// h5_sdk_params，uid/pn 等和主页面一致。登录态 token 随地址一起带过去：新 WebView 的
// localStorage 不一定和主页面共享（iOS），只靠 vuex-persistedstate 会出现已登录却没 token。
// 提现页的 exit() 已经优先调 jskit.closePage()，返回即关掉这层 WebView。
import http from '@/utils/http'
import store from '@/store'
import features from '@/config/features'

// 没有 jskit（纯浏览器、老版本壳）时的兜底：仍在当前 WebView 内跳转。
// iOS 壳也注入了 jskit.startPortraitPage，但新 WebView 读不到 iframe 内的 localStorage，
// 登录态带不过去；iOS 一律页内跳转，与 My Cash 共用内存里的 token
function canOpenPortraitPage () {
  if (window.webkit && window.webkit.messageHandlers) {
    return false
  }
  return !!(window.jskit && window.jskit.startPortraitPage)
}

// Vue 提现页是 hash 路由，拼成绝对地址给壳打开；query 原样带上（不要重新编码，pn/uid 等按原样透传）。
// 实测壳层打开新 WebView 时 #fragment 会丢，落地直接被路由重定向回首页，
// 所以再用 query 带一份 entry=withdraw-us，由 index.html 在 SPA 启动前把 hash 补回来。
export function vueWithdrawUrl () {
  const { origin, pathname, search } = window.location
  const sep = search ? '&' : '?'
  const token = encodeURIComponent(store.state.token || '')
  return `${origin}${pathname}${search}${sep}entry=withdraw-us&token=${token}#/withdraw-us`
}

export function openWithdrawUs (router) {
  // flag 控制：新 Vue 提现页 or 旧静态 html 提现页
  if (features.vueWithdraw) {
    if (canOpenPortraitPage()) {
      window.jskit.startPortraitPage(vueWithdrawUrl())
    } else {
      router.push('/withdraw-us')
    }
    return
  }

  const urlParams = window.location.search
  if (canOpenPortraitPage()) {
    window.jskit.startPortraitPage(`${http.baseH5Url}/withdraw/withdraw-us.html${urlParams}`)
  } else {
    window.location.href = http.baseH5Url + '/withdraw/withdraw-us.html' + urlParams
  }
}

export default { openWithdrawUs, vueWithdrawUrl }
